import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import userService from '../../services/user.service';
import { sourceUrl } from '../../environment';
import { toastOptions } from '../shared/selectStyle';
import './style.css';
import ModalYesNo from '../shared/modalYesNo';
const modalText = "Are you sure you want to remove this member from your company?";
const modalHeading = "Remove";
const ListMembers = (props) => {
  const { t } = useTranslation();
  const [members, setMembers] = useState([]);
  const [memberId, setMemberId] = useState({});
  const [showModalDelete, setShowModalDelete] = useState(false);

  useEffect(() => {
    getListCompanyMembers(props.companyId);
  }, [props.changed]);

  const getListCompanyMembers = async (companyId) => {
    const response = await userService.listAllCompanyUsers(companyId);
    setMembers(response);
  }
  const removeMemeber = async (userId) => {
    await userService.removeUserFromCompany(userId);
    toast.success("Member is successfully removed!", toastOptions);
    props.isChanged();
  }

  const closeModal = async () => {
    setShowModalDelete(false);
  }

  const openYesNoModal = (memberId) => {
    setMemberId(memberId);
    setShowModalDelete(true);
  }
  const handleYesNoAnswer = (answer) => {
    if (answer === 'yes') {
      removeMemeber(memberId)
      closeModal();
    } else {
      closeModal();
    }
  }
  return (
    <div>
      {members && members.length ? <h4 className="h4-title">{t('company.listMemebers.title')}</h4> : null}
      {members && members.length ?
        <ul className="users-list">
          <li className="heading-users">
            <ul>
              <li className="wd-40">{t('company.listMemebers.members')}</li>
              <li className="wd-40">{t('placeholder.email')}</li>
              <li className="user-admin-hd wd-10">{t('edit')}</li>
              <li className="user-admin-hd wd-10">{t('remove')}</li>
            </ul>
          </li>
          {members.map((member, i) =>
            <li key={member._id} className="body-users">
              <ul>
                <li className="username-box wd-40">
                  <img className="user-img" src={member.avatarId ? `${sourceUrl}${member.avatarId}.${member.avatarExt}` : `/assets/images/avatar.png`} alt={member.email} />
                  <span>{member.firstName} {member.lastName} </span>

                </li>
                <li className="email-box wd-40">
                  <span>{member.email}</span>
                </li>
                <li className="edit-user wd-10"><Link className="btn btn-orange" to={`/dashboard/member/${member._id}`}> <img src="/assets/images/dots.svg" alt="Edit" /> </Link></li>
                <li className="delete-user wd-10"><i className="fa fa-trash" aria-hidden="true" onClick={() => { openYesNoModal(member._id) }}></i></li>
              </ul>
            </li>
          )}
        </ul> : null}
      {showModalDelete ? <ModalYesNo heading={modalHeading} text={modalText} show={showModalDelete} closeModal={closeModal} handleYesNoAnswer={handleYesNoAnswer} /> : null}
    </div>
  );
}

export default ListMembers;


// WEBPACK FOOTER //
// ./src/components/companyComponent/lisMembers.js